import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

import SysRecord from "app/class/record";
import SysTable from "app/class/sys-table";
import { RecordManagement } from "app/class/record-management";
import queryKeys from "shared/services/queryKeys";

export const useRelatedListDefinitions = (
    table: SysTable | null,
    tablesLoaded: boolean,
    parentTableName?: string | null
) => {
    const { data, isLoading } = useQuery({
        queryKey: queryKeys.records.config("sys_related_list", { source_table: table?.id }),
        select: (response) => response.data as SysRecord[],
        queryFn: () => {
            return new RecordManagement("sys_related_list")
                .where("active", true)
                .where("source_table", table?.id)
                .orWhere("source_table", "empty")
                .run();
        },
        enabled: !!table && tablesLoaded,
        retry: false,
    });

    const relatedLists = useMemo(
        () => [...(data ?? [])]
            .filter((definition) => definition.relationship_type !== "inheritance_ancestors" || Boolean(parentTableName))
            .sort((left, right) => left.order - right.order),
        [data, parentTableName]
    );

    return {
        relatedLists,
        isLoading,
        hasRelatedLists: relatedLists.length > 0,
    };
};
